import React, { useState, useEffect, createContext, useContext } from 'react'
import { signInAnonymously } from 'firebase/auth'
import { auth } from '../services/firebase'
import { useFirestoreItem } from '../hooks/useProject'
import propTypes from 'prop-types'

const AuthContext = createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null)
  const [loading, setLoading] = useState(true)
  const [showModal, setShowModal] = useState(false)
  const [destination, setDestination] = useState(null)
  const initialErrorState = { active: false, count: 0 }
  const [error, setError] = useState(initialErrorState)

  const fsPasscode = useFirestoreItem('passcodes', 'passcode')

  const login = (passcode) => {
    event.preventDefault() // Prevent the default form submission behavior

    return new Promise((resolve, reject) => {
      // Check if the passcode is valid
      if (fsPasscode.accessPasscode === passcode) {
        // If valid, call signInAnonymously and resolve the Promise
        signInAnonymously(auth)
          .then(() => {
            // console.log('User signed in anonymously:', auth) // Log the success
            resolve() // Resolve the Promise to indicate success
          })
          .catch((error) => {
            console.error('Failed to sign in anonymously:', error) // Log any sign-in error
            reject(error) // Reject the Promise with the error
          })
      } else {
        // If the passcode is invalid, reject and set the error state
        setError((prevError) => ({
          ...prevError,
          active: true,
          count: error.count++,
        })) // Update the UI to reflect the error state
        reject(new Error('Invalid passcode.')) // Pass the error to the caller
      }
    })
  }

  const logout = () => {
    // console.log('User signed out')
    return auth.signOut()
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user)
      setLoading(false)
    })

    return unsubscribe
  }, [])

  const value = {
    currentUser,
    login,
    logout,
    showModal,
    setShowModal,
    destination,
    setDestination,
    error,
    incrementError: () =>
      setError((prevError) => ({
        ...prevError,
        count: error.count++,
      })),
    clearError: () => setError(initialErrorState),
  }

  AuthProvider.propTypes = {
    children: propTypes.oneOfType([
      propTypes.array,
      propTypes.shape(),
      propTypes.string,
    ]),
  }

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
